import React, { useState } from "react";
import CookieConsent from "react-cookie-consent";

const CookiesNotification = () => {
  const [accepted, setAccepted] = useState(
    localStorage.getItem("cookiesAccepted")
  );

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setAccepted(true);
    // Perform any necessary actions when the user accepts the cookies
  };

  if (accepted) {
    return null; // If the user has already accepted, do not display the notification
  }

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="cookieConsent"
      style={{ background: "#333", color: "#fff" }}
      buttonStyle={{
        background: "var(--primary)",
        color: "#fff",
        fontSize: "16px",
        width: "200px",
        height: "50px",
        fontWeight: "600",
      }}
      expires={365}
      onAccept={handleAccept}
    >
      This website uses cookies to enhance the user experience.
    </CookieConsent>
  );
};

export default CookiesNotification;
